import { css } from '@emotion/react'
import { observer } from 'mobx-react'
import { isTablet } from 'react-device-detect'
import { useRouteMatch } from 'react-router-dom'

import Header from '@/component/organisms/Header'
import { RouteName } from '@/router/RouteName'
import type { DefaultProps } from '@/types'

const FULL_PAGE_ROUTE_MATCH_LIST = [RouteName.schoolExamZone, RouteName.updatedContents]
export const dividedTemplateOptionRoutes: string[] = [RouteName.kmmRoot, RouteName.customPrint]

const DefaultPageTemplate = ({ children }: DefaultProps) => {
  const isFullPageRouteMatched = useRouteMatch(FULL_PAGE_ROUTE_MATCH_LIST)

  return (
    <>
      <Header />
      {isFullPageRouteMatched ? (
        children
      ) : (
        <>
          <main css={_Style}>
            <div className="page-container">
              <div className="page-container-inner">{children}</div>
            </div>
          </main>
        </>
      )}
    </>
  )
}

export default observer(DefaultPageTemplate)

const _Style = css`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 16px 0;
  background: var(--Colors-Gray-200);

  ${isTablet &&
  css`
    height: calc(100% + 62px); // height + header height + padding
  `}

  .page-container {
    display: flex;
    width: 100%;
    height: 100%;
    max-width: 1920px;
    padding: 0 24px;

    .page-container-inner {
      display: flex;
      gap: 16px;
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
`
